import { QrCode, Smartphone, Wallet, Wifi } from "lucide-react";
import { WHY_FEATURES } from "../content/landing";
import { useT } from "../i18n";
import { cardClass, sectionHeading, sectionSubheading } from "../lib/ui";

const WHY_ICONS = {
  noApp: Smartphone,
  blik: Wallet,
  realtime: Wifi,
  ready: QrCode,
} as const;

export default function WhyBarmaid() {
  const translate = useT();

  return (
    <section
      id="why-barmaid"
      className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24"
      aria-labelledby="why-barmaid-heading"
    >
      <div className="max-w-2xl">
        <h2 id="why-barmaid-heading" className={sectionHeading}>
          {translate("whyTitle")}
        </h2>
        <p className={sectionSubheading}>{translate("whySubtitle")}</p>
      </div>

      <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-2">
        {WHY_FEATURES.map((feature) => {
          const Icon = WHY_ICONS[feature.icon];
          return (
            <li key={feature.icon} className={`${cardClass} bg-brand-soft p-5`}>
              <div className="flex items-start gap-4">
                <div className="inline-flex shrink-0 rounded-xl bg-surface p-2.5 shadow-card">
                  <Icon className="h-5 w-5 text-accent" aria-hidden />
                </div>
                <div>
                  <h3 className="font-display font-semibold">{translate(feature.titleKey)}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                    {translate(feature.bodyKey)}
                  </p>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
